import { HttpErrorResponse } from '@angular/common/http'
import { Component, OnInit } from '@angular/core'
import { Router } from '@angular/router'
import { AuthTokenService } from '@helios/auth'
import { SessionsService } from '@helios/sessions'
import { setUserPolicy } from '@helios/state-management'
import { Store } from '@ngrx/store'
// eslint-disable-next-line @nrwl/nx/enforce-module-boundaries
// eslint-disable-next-line @nrwl/nx/enforce-module-boundaries
import { HttpUserService } from 'libs/sessions/src/lib/services/http-user-service/http-user.service'
import { paths } from '../paths'

@Component({
  selector: 'hs-new-user-setup',
  templateUrl: './new-user-setup.component.html',
  styleUrls: ['./new-user-setup.component.scss'],
})
export class NewUserSetupComponent implements OnInit {
  constructor(
    private readonly sessionsService: SessionsService,
    private readonly router: Router,
    private readonly authTokenService: AuthTokenService,
    private readonly store: Store,
    private readonly httpUserService: HttpUserService,
  ) {}

  displayNoPermissionMsg = false

  ngOnInit(): void {
    this.authTokenService.getToken(true).then(() => {
      this.getSessions(0)
    })
  }

  getSessions(retryCount: number) {
    this.sessionsService
      .loadSessions()
      .then(() => {
        this.httpUserService.getUserPolicy().then(policy => {
          this.store.dispatch(setUserPolicy({ userPolicy: policy }))
        })
        this.router.navigateByUrl('/').then(() => {
          this.router.navigate([paths.base]).then(() => {
            window.location.reload()
          })
        })
      })
      .catch((res: HttpErrorResponse) => {
        if (res.status == 403) {
          this.authTokenService.getToken(true)
          if (retryCount < 15) {
            setTimeout(() => (this.getSessions(retryCount + 1), 1000))
          } else {
            this.displayNoPermissionMsg = true
          }
        }
      })
  }
}
